import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { getToken, setUserSession, getUser } from "../../../Utils/Common";
import { ResponseMessage } from "../../../components/messages/response-message";

import { useNavigate } from "react-router-dom";

export default function CreatePayment() {
  const token = getToken();
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [subscription, setSubscription] = useState({});

  useEffect(() => {
    //Check to see if this is a redirect back from Checkout
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}v1/user/get-subscription`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.data.status === "canceled") {
            navigate("/account");
          }
          setStatus(200);
          console.log(response.data.data.status);
          setSubscription(response.data.data);
          setUserSession(token, response.data.user);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error.response);
        setLoader(false);
        if (error.response.status === 500) {
          console.log(error.response);
          setStatus(500);
        } else if (error.response.status === 401) {
          setStatus(401);
          console.log(error.response);
        } else if (error.response.status === 404) {
          setStatus(404);
          console.log(error.response.data.message);
          setMessage(error.response.data.message);
          navigate("/account");
        } else {
        }
      });
  }, []);

  console.log(subscription);

  // const makeTran = () => {
  //   setLoader(true);
  //   axios({
  //     method: "post",
  //     url: `${process.env.REACT_APP_API_URL}v1/user/create-payment`,
  //     headers: {
  //       Accept: "application/json",
  //       "content-Type": "application/json",
  //       Authorization: `Bearer ${token}`,
  //     },
  //     data: {
  //       price: "price_1KqA0vHuNOGPY9jahyBq6gXN",
  //     },
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         console.log(response.data);
  //         window.location.replace(response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.response.status === 500) {
  //         console.log(error.response);
  //       } else if (error.response.status === 401) {
  //         console.log(error.response);
  //       } else if (error.response.status === 422) {
  //         console.log(error.response.data.message);
  //         setMessage(error.response.data.message);
  //       } else {
  //       }
  //     })
  //     .then(() => {
  //       setLoader(false);
  //     });
  // };

  return (
    <>
      <div className="d-flex justify-content-center">
        <div className={loader === true ? "spinner-border" : ""} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>

      {/* {status && status === 404 ? (
        <div
          className="d-flex flex-column flex-root"
          style={{ marginTop: "140px" }}
        >
          <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
            <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
              <div className="d-flex justify-content-center">
                <div
                  className={loader === true ? "spinner-border" : ""}
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
              <div
                className="text-center"
                style={{ fontFamily: "Microsoft YaHei" }}
              >
                <h1 className="fs-3tx fw-normal">Special Offer</h1>
                <h3 className="fs-2tx fw-normal">
                  Only for subscribed members
                </h3>
                <div
                  className="p-10 border-black"
                  style={{ minWidth: "670px" }}
                >
                  <div
                    className="fs-2tqx rounded-circle"
                    style={{
                      border: "7px solid black",
                      maxWidth: "150px",
                      fontSize: "85px",
                      margin: "auto",
                    }}
                  >
                    3
                  </div>
                  <h2 className="fs-2x fw-bolder mt-5">3 Extra Credits</h2>
                  <h2 className="fs-2x fw-bolder mt-5">$24.99</h2>
                  <h2 className="fs-2x fw-bold mt-5">Only $8.33/credit</h2>

                  <button
                    className="btn btn-lg btn-dark w-100 mt-5 fs-2hx"
                    // onClick={makeTran}
                    disabled
                  >
                    <span className="indicator-label">Buy Now</span>
                  </button>

                  <h2 className="fs-2x fw-bold mt-5">
                    Offer available for a limited time only.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )} */}

      {status && status === 200 ? (
        <div
          className="d-flex flex-column flex-root"
          style={{ marginTop: "140px" }}
        >
          <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
            <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
              <div className="d-flex justify-content-center">
                <div
                  className={loader === true ? "spinner-border" : ""}
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
              <div
                className="text-center"
                style={{ fontFamily: "Microsoft YaHei" }}
              >
                <h1 className="fs-3tx fw-normal">Special Offer</h1>
                <h3 className="fs-2tx fw-normal">
                  Only for subscribed members
                </h3>
                <div
                  className="p-10 border-black"
                  // style={{ minWidth: "670px" }}
                >
                  <div
                    className="fs-2tqx rounded-circle"
                    style={{
                      border: "7px solid black",
                      maxWidth: "150px",
                      fontSize: "85px",
                      margin: "auto",
                    }}
                  >
                    3
                  </div>
                  <h2 className="fs-2x fw-bolder mt-5">3 Extra Credits</h2>
                  <h2 className="fs-2x fw-bolder mt-5">$24.99</h2>
                  <h2 className="fs-2x fw-bold mt-5">Only $8.33/credit</h2>

                  <Link
                    className="btn btn-lg btn-dark w-100 mt-5 fs-2hx"
                    to={`/buy/confirm-purchase`}
                    // onClick={makeTran}
                  >
                    <span className="indicator-label">Buy Now</span>
                  </Link>

                  <h2 className="fs-2x fw-bold mt-5">
                    Offer available for a limited time only.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
